export default (state = '', action) => {
  switch (action.type) {
    case 'RECEIVE_CATEGORY_ADV':
      return action.p;
    case 'RECEIVE_CATEGORY_ADV_ERROR':
        return action.p;
    default:
      return state;
  }
};

// // selectors
//
// export const getAccessoriesByCategoryId = (categoryId, categoryAccessories) => {
//
// };



// WEBPACK FOOTER //
// ./src/store/reducers/category-adv.js